import React from 'react';

import Trash from 'assets/icons/trash.svg';
import Undo from 'assets/icons/undo.svg';
import Send from 'assets/icons/send.svg';
import Download from 'assets/icons/download.svg';

type IconButtonProps = {
  type: string;
  className?: string;
  onClick?: () => void;
};

function IconButton({className, type, onClick}: IconButtonProps) {
  let src = '';
  switch (type) {
    case 'delete':
      src = Trash;
      break;
    case 'undo':
      src = Undo;
      break;
    case 'send':
      src = Send;
      break;
    case 'download':
      src = Download;
      break;
    default:
  }

  return (
    <button
      className={`focus:outline-none ${className || ''}`}
      onClick={onClick}
    >
      <img src={src} alt={src} className="m-auto" />
    </button>
  );
}

export default IconButton;
